import React from 'react';
import { Theme } from '@indigo-ag/component-module';
import { Link } from 'react-router-dom';

import { createStylesHook } from 'shared/hooks/createStylesHook';

interface NavItemProps {
  active?: boolean;
  path: string;
  children: JSX.Element;
}

const useStyles = createStylesHook((theme: Theme) => ({
  navItem: {
    color: '#00577D',
    height: '100%',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    padding: '0 24px !important',
    cursor: 'pointer',
    transition: 'background-color 150ms',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    borderLeft: '1px solid #E4EEF3',
    '&.active': {
      boxShadow: 'inset 0 -3px 0 0 #00577D'
    },
    '&:hover': {
      backgroundColor: '#F0F7FB'
    }
  }
}));

export const NavItem: React.FunctionComponent<NavItemProps> = ({ active = false, path, children, ...rest }) => {
  /**
   * Styles
   */
  const classes = useStyles({});

  return (
    <Link data-test={rest['data-test']} className={`${classes.navItem} ${active ? 'active' : ''}`} to={path}>
      {children}
    </Link>
  );
};
